import React from 'react';
import noContentSrc from 'images/ollie_calendar.svg';
import BlankSlate from 'components/_shared/blank_slate/_blank_slate';
import Heading from 'components/_shared/blank_slate/heading';

const EmptyState = () => (
  <BlankSlate large className="Animated Animated--fadeIn">
    <img
      className="mh-300"
      src={noContentSrc}
      alt={t('in_person_training.events_dashboard.empty_state.description')}
    />
    <br />
    <Heading>
      {t('in_person_training.events_dashboard.empty_state.description')}
    </Heading>
  </BlankSlate>
);

export default EmptyState;
